import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "./ErrorFallback";

interface ChunkLoadErrorBoundaryProps {
  children: React.ReactNode;
}

export const ChunkLoadErrorBoundary = (props: ChunkLoadErrorBoundaryProps) => {
  const { children } = props;
  return (
    <ErrorBoundary
      onError={(error) => {
        if (error.name !== "ChunkLoadError") {
          throw error; // Propagate other errors
        }
      }}
      fallbackRender={({ error, resetErrorBoundary }) => (
        <ErrorFallback
          error={error}
          resetErrorBoundary={resetErrorBoundary}
        />
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
